/**
 * Holding Companies Mapper
 * Maps transport DTOs to internal models
 */

import type {
  LC_GetHoldingCompaniesOut,
  LC_HoldingCompanyItem,
  HoldingCompany,
} from './holding.types';

/**
 * Maps backend holding companies response to internal model array
 * @param out - Backend response array with holding companies
 * @returns Array of HoldingCompany internal models
 */
export const mapHoldingCompanies = (
  out: LC_GetHoldingCompaniesOut,
): HoldingCompany[] => (
  out.map((item: LC_HoldingCompanyItem) => ({
    id: item.companyId,
    name: item.companyName || '',
    parentHoldingCompanyId: item.parentHoldingCompanyId ?? undefined,
  }))
);
